<template>
  <div
    class="boxBig"
    v-loading="loading"
    :element-loading-text="loadingTitle"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  ></div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      loadingTitle: "加载中...",
    };
  },
  created() {
    const hash = window.location.hash;
    if (hash) {
      const dataParamMatch = hash.match(/data=([^&]+)/);
      if (dataParamMatch && dataParamMatch[1]) {
        const dataParam = dataParamMatch[1];
        try {
          let receivedObject = JSON.parse(decodeURIComponent(dataParam));
          if (receivedObject.type == "cut") {
            console.log(receivedObject, "切换地址收到的参数index");

            this.$store.dispatch("set_token", receivedObject);
            if (receivedObject.sceneInfo.length > 0) {
              localStorage.setItem(
                "sceneInfo",
                JSON.stringify(receivedObject.sceneInfo)
              );
              if (receivedObject.sceneInfo.length > 1) {
                // this.$router.push("/sceneSelect");
                window.sessionStorage["sceneId"] = receivedObject.sceneId;
                window.sessionStorage["sceneName"] = receivedObject.sceneName;
                this.$api.system
                  .sceneChange({
                    sceneId: receivedObject.sceneId,
                    sceneName: receivedObject.sceneName,
                  })
                  .then((res) => {
                    this.$router.push("/index/inxdex");
                  });
                var sceneId = store.getters.get_sceneId;
              } else {
                window.sessionStorage["sceneId"] = Number(
                  receivedObject.sceneInfo[0]
                );
                window.sessionStorage["sceneName"] =
                  Number(receivedObject.sceneInfo[0]) === 1
                    ? "景区场景"
                    : Number(receivedObject.sceneInfo[0]) == 2
                    ? "校园场景"
                    : "社区场景";
                this.$api.system
                  .sceneChange({
                    sceneId: Number(receivedObject.sceneInfo[0]),
                    sceneName:
                      Number(receivedObject.sceneInfo[0]) === 1
                        ? "景区场景"
                        : Number(receivedObject.sceneInfo[0]) == 2
                        ? "校园场景"
                        : "社区场景",
                  })
                  .then((res) => {
                    this.$router.push("/index/inxdex");
                  });
              }
            }
          }
        } catch (error) {
          console.error("Error parsing data parameter:", error);
          this.dataObj = {}; // 清空数据对象以避免显示错误的数据
        }
      }
    }

    // // 获取网址
    // // 获取当前页面的 URL
    // const currentUrl = window.location.href;

    // // 使用 URL 对象来解析
    // const url = new URL(currentUrl);

    // // 使用 URLSearchParams 获取查询参数
    // const params = new URLSearchParams(url.search);

    // // 获取名为 'data' 的参数
    // const dataString = params.get("data");
    // console.log(dataString, "dataStringdataStringdataString");

    // if (dataString) {
    //   // 解码并解析为对象
    //   const receivedObject = JSON.parse(decodeURIComponent(dataString));
    //   if (receivedObject.type == "cut") {
    //     console.log(receivedObject, "切换地址收到的参数index");

    //     this.$store.dispatch("set_token", receivedObject);
    //     if (receivedObject.sceneInfo.length > 0) {
    //       localStorage.setItem(
    //         "sceneInfo",
    //         JSON.stringify(receivedObject.sceneInfo)
    //       );
    //       if (receivedObject.sceneInfo.length > 1) {
    //         // this.$router.push("/sceneSelect");
    //         window.sessionStorage["sceneId"] = receivedObject.sceneId;
    //         window.sessionStorage["sceneName"] = receivedObject.sceneName;
    //         this.$api.system
    //           .sceneChange({
    //             sceneId: receivedObject.sceneId,
    //             sceneName: receivedObject.sceneName,
    //           })
    //           .then((res) => {
    //             this.$router.push("/index/inxdex");
    //           });
    //         var sceneId = store.getters.get_sceneId;
    //       } else {
    //         window.sessionStorage["sceneId"] = Number(
    //           receivedObject.sceneInfo[0]
    //         );
    //         window.sessionStorage["sceneName"] =
    //           Number(receivedObject.sceneInfo[0]) === 1
    //             ? "景区场景"
    //             : Number(receivedObject.sceneInfo[0]) == 2
    //             ? "校园场景"
    //             : "社区场景";
    //         this.$api.system
    //           .sceneChange({
    //             sceneId: Number(receivedObject.sceneInfo[0]),
    //             sceneName:
    //               Number(receivedObject.sceneInfo[0]) === 1
    //                 ? "景区场景"
    //                 : Number(receivedObject.sceneInfo[0]) == 2
    //                 ? "校园场景"
    //                 : "社区场景",
    //           })
    //           .then((res) => {
    //             this.$router.push("/index/inxdex");
    //           });
    //       }
    //     }
    //   }
    // } else {
    //   console.log("没有传递数据");
    // }
  },
};
</script>

<style lang="scss" scoped>
.boxBig {
  width: 100%;
  height: 100%;
  background: #fff;
}
/deep/ .el-loading-spinner i {
  color: #fff !important;
  font-size: 40px;
}
/deep/ .el-loading-spinner .el-loading-text {
  color: #fff;
  margin: 3px 0;
  font-size: 14px;
  margin-top: 15px;
}
</style>
